import React from "react";
import ReactDOM from "react-dom";
import CloseButton from "components/ui/close-button";

const Modal = ({ children, isOpen, closeModal, modalContentClass }) => {
  return (
    <>
      {ReactDOM.createPortal(
        <div
          className={`fixed top-0 left-0 h-full w-full bg-ink bg-opacity-70 z-[250] ${
            isOpen ? "block" : "hidden"
          }`}
        />,
        document.body
      )}
      {ReactDOM.createPortal(
        <div
          style={{ transform: "translate(-50%, -50%)" }}
          className={`fixed left-1/2 top-1/2 bg-white shadow-pop border border-solid border-ink rounded-ns-tile z-[260] modal-content ${modalContentClass} ${
            isOpen ? "block" : "hidden"
          }`}
        >
          <div className="relative w-full">
            <div className="py-10 px-6 lg:px-14 w-full max-h-[82vh] overflow-y-auto">{children}</div>
            {/* Was a white raster CloseIcon on an ink disc with
                `filter: invert(1)` bolted on to make it visible at all — a
                workaround for the asset being a picture rather than an icon. */}
            <CloseButton onClick={closeModal} className="absolute right-4 top-3" />
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default Modal;